<template>
    <small v-bind:style="computedStyle">(UTC<span v-if="fusoHorario != 'UTC'">{{ _fusoHorario }}</span>
	<span v-else></span>)</small>
</template>
<script>
export default{
    props: {
        fusoHorario: {
            type: String,
            default: 'local',
            required: true
        },
        cor: {
            type: String,
            default: ''
        }
    },
    computed: {
        computedStyle() {
            return this.cor ? { color: this.cor } : {};
        }
    }
}
</script>